export default subscription => subscription.subscription_type === 'employee'
